/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-10-10 15:27:48
 */

import { request } from "./api-require";

const API_URL = "/oms-charge-service/v1";
import { objAny } from "../common/common-interface";
export const getPageChargerRecord = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/page/charger_record", data, config);
};

//分页获取订单信息列表
export const getOrderPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/page", data, config);
};

//根据主键查询订单详细信息
export const getOrderDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/detail", data, config);
};

//处理异常订单
export const getHandleOrder = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/handleOrder", data, config);
};

//获取充电枪最近一笔订单
export const getOrderLatest = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/latest", data, config);
};

//获取充电枪订单充电曲线图数据
export const getOrderCurveCharge = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/curve/charge", data, config);
};

//获取充电枪订单温度曲线图数据
export const getOrderCurveTemperature = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/curve/temperature", data, config);
};

//获取充电枪订单温度曲线图数据
export const getOrderFeeDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/fee_detail", data, config);
};
//获取电池曲线图数据
export const getCurveBettery = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/curve/bettery", data, config);
};
//异常订单信息
export const getOrderAbnormal = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/abnormal", data, config);
};

//异常订单信息
export const getHandleAbnormal = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/abnormal/handle", data, config);
};

//结束充电
export const getChargeStop = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/charge/stop", data, config);
};

//结束充电
export const getOrderGunChargingInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/gun/charging_info", data, config);
};
//强制结束充电
export const chargeforceStop = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/charge/force_stop", data, config);
};
//获取充电状态
export const getOrderStatus = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/status", data, config);
};

// 根据条件分页查询桩充电资金记录列表
export const getOrderChargeRecode = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/page/pile/charge_recode", data, config);
};
// 分页获取离线卡订单信息列表
export const getOfflineCard = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/offline/page/offline_card", data, config);
};
// 统计离线卡充电订单信息
export const getTotalOfflineCard = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/offline/total/offline_card", data, config);
};
// 获取离线卡订单信息详情
export const getOfflineCardDetails = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/offline/detail/offline_card", data, config);
};
//获取订单异常信息
export const getOrderFaults = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/faults", data, config);
};
//获取充电枪订单计费曲线图数据
export const getOrderCurveCharging = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/curve/charging", data, config);
};
//获取订单统计信息
export const getStatistics = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/getStatistics", data, config);
};
